import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Reporte/reporteDespachosBancos';
import ReporteDespachosBancos from './ReporteDespachosBancos'

const mstp = state => {
    return {
        ...state.reporteDespachosBancos,
        permisos: state.login.me.permisos
    }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(ReporteDespachosBancos)
